<template>
    <div class="a-dropdown dropdown">
        <Select
            v-model="localValue"
            :disabled="disabled"
            :placement="placement"
            :prefix="prefixCssClass"
            :filterable="filterable"
            :placeholder="placeholder"
            :clearable="clearable"
            @on-change="handleChange"
            @on-clear="handleClear"
            @on-open-change="handleOpenChange"
            ref="iSelect"
            :capture="false"
        >
            <Option
                v-for="(item, index) in items"
                :key="index + '-' + randomKeyPrefix + '-' + item[keyField]"
                :at-a-dropdown-options="item[keyField]"
                :value="item[keyField]"
                :label="item[nameField]"
                :class="{
                    'hide-option__': item[keyField] === value,
                    'ivu-select-item-focus': item[keyField] == value
                }"
                :disabled="item[keyField] === value"
            >
                <slot name="select-option" :option="item">
                    {{ item[nameField] }}
                </slot>
            </Option>
            <template #prefix v-if="isPrefix">
                <svg-icon
                    original
                    :name="`locales/${localValue}`"
                    class="dropdown__icon"
                />
            </template>
        </Select>
        <slot name="prefix">
            <div 
                class="clearable"
                v-if="clearable"
            >
                <svg-icon
                    original
                    name="icons/search-otg"
                    class="search-icon"
                />
                <!-- <Icon @click.stop="clearSelect" type="ios-close-circle" /> -->
            </div>
        </slot>
    </div>
</template>
<script>
// import {Icon} from 'view-design'
export default {
    name: 'ADropdown',
    components: {
        // Icon
    },
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        items: {
            type: Array,
            default: () => []
        },
        nameField: {
            type: String,
            default: 'name'
        },
        keyField: {
            type: String,
            default: 'id'
        },
        isPrefix: {
            type: Boolean,
            default: false
        },
        placement: {
            type: String,
            default: 'bottom-start'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        filterable: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: [String, null],
            default: 'Select'
        }
    },
    watch: {
        items() {
            this.$refs.iSelect.focusIndex = -1;
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e);
            }
        },
        randomKeyPrefix(){
            return Math.floor(Math.random() * 1000);
        },
        prefixCssClass() {
            return this.isPrefix
                ? `dropdown__header-icon--${this.localValue}`
                : null;
        }
    },
    methods: {
        handleOpenChange(e) {
            this.$emit('onOpenChange', e);
        },
        handleChange(e) {
            const focusIndex = this.items.findIndex(item => item[this.keyField] == this.value)
            if(focusIndex || focusIndex === 0) this.$refs.iSelect.focusIndex = focusIndex;
            e && this.$emit('onChange', e);
            if(this.filterable && e ) {
                this.$nextTick(() => {
                    const tmp = document.createElement("input");
                    document.body.appendChild(tmp);
                    tmp.focus();
                    document.body.removeChild(tmp);
                })
                
            }
        },
        handleClear() {
            this.$emit('onClear');
        },
        clearSelect() {
            this.$refs.iSelect.setQuery(null);
            this.$refs.iSelect.$children[0]._vnode.children[6].elm.value = '';
        },
        toggleMenu() {
            this.$refs.iSelect.toggleMenu()
        }
    }
};
</script>

<style lang="scss" src="./a-dropdown.scss" />